module.exports = __webpack_public_path__ + "static/media/umbrella-green.a91ffb75.svg";